import React, { useState,useEffect } from 'react';
import { IonList,IonLabel,IonBadge ,IonButton, IonItem,IonRange,IonIcon, IonText,IonGrid, IonRow, IonCol } from '@ionic/react';



interface ContainerProps {
    title: string;
    description: string;
    name: string;
  min:number;
  max:number;
  defaultValue:number;
  step:number;
  hideparams:number;
  handler:(value:number)=>void;
}
const customFormatter = (value: number) => `${value}`;

const Control: React.FC<ContainerProps> = ({ hideparams,title,description,name,min,max,defaultValue,step,handler }) => {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        handler(value);
        
    }, [value]);

    if(hideparams===1) return(<></>);
    else
    return (
            <IonGrid>

            <IonRow className="ion-justify-content-start">
            <IonCol  size='auto' style={{paddingBottom:'0px'}}>
                <IonBadge color="light"  className="padding0">{value}</IonBadge>
                </IonCol>
            <IonCol style={{paddingBottom:'0px'}}>
                <div  className="ParamDetail" style={{textAlign:"left"}}>
            <IonText className='f1 '>{title}<span className='hiddenmobile'>: {description}</span></IonText></div>
                                 </IonCol>
            </IonRow>
            <IonRow className="padding0 ion-justify-content-start">
            <IonCol >
            <IonRange className="ion-no-padding" style={{height:"24px"}} value={value} min={min} max={max} step={step} snaps={true} ticks={false}
                    onIonChange={e => setValue(e.detail.value as number)}
                    pinFormatter={customFormatter} 
                >
                </IonRange>

            </IonCol>
            </IonRow>
            </IonGrid>

  );
};

export default Control;
